import MenuItems from './MenuItems';
import './style.scss';

export default MenuItems;
